import { useQuery } from '@tanstack/react-query';

import { getSeniorities } from '@/modules/settings/api/seniorities.api';

/**
 * Hook to fetch all seniorities with lazy loading support.
 * No pagination needed - returns complete list.
 *
 * @param enabled - Whether to enable the query (default: true). Set to false for lazy loading.
 */
export const useSeniorities = (enabled = true) => {
  return useQuery({
    queryKey: ['seniorities'],
    queryFn: getSeniorities,
    staleTime: 10 * 60 * 1000, // 10 minutes
    enabled,
  });
};
